<template>
    <div v-if="skills.length">
        <div class="ds-exchange-card-skills-label pb-2">Навыки:</div>
        <div class="ds-exchange-card-skills mb-4">
            <div v-for="skill in skills" :key="skill.id" class="ds-exchange-skill-chip">{{ skill.name }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">

interface Props {
    skills: any[]
}

const { skills } = defineProps<Props>()

</script>
